export default __webpack_public_path__ + "media/images/home/living_utilities-6f3185426fe667bc48ff4c2e3d9b7fb4.webp";